<script>
import { startBackgroundMonitor } from '@/services/api/devices/list'
export default {
  render () {
   return null // render nothing
  },
  data () {
    return {
      handle: null
    }
  },
  mounted () {
    this.handle = startBackgroundMonitor(5/*mins*/*60*1000)
  },
  beforeDestroy () {
    if (this.handle) {
      clearInterval(this.handle)
      this.handle = null
    }
  }
}
</script>